import { render } from "./Customizations.vue?vue&type=template&id=39bfbd0c"
import script from "./Customizations.vue?vue&type=script&lang=ts"
export * from "./Customizations.vue?vue&type=script&lang=ts"

import "./Customizations.vue?vue&type=style&index=0&id=39bfbd0c&lang=css"
script.render = render

export default script